import { render, staticRenderFns } from "./BaseCurrencySelect.vue?vue&type=template&id=1007c54d&scoped=true&"
import script from "./BaseCurrencySelect.vue?vue&type=script&lang=js&"
export * from "./BaseCurrencySelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseCurrencySelect.vue?vue&type=style&index=0&id=1007c54d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1007c54d",
  null
  
)

export default component.exports